<template lang="pug">
  div.individuals.individual-update
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    @deleteItem="deleteItem()"
    :hideDeleteButton="(fields.id ? true : false)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs()
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div
            div.body
              div.col

                e-form-subtitle(text="Реквизиты")

                div.col-sub-cols-2
                  e-form-group(
                  name="surname"
                  inputType="input"
                  label="Фамилия"
                  :model="fields"
                    :required="false"
                  tabView="tab1"
                  )
                  e-form-group(
                  name="name"
                  inputType="input"
                  label="Имя"
                  :model="fields"
                    :required="false"
                  tabView="tab1"
                  )
                  e-form-group(
                  name="patronymic"
                  inputType="input"
                  label="Отчество (при наличии)"
                  :model="fields"
                  tabView="tab1"
                  )
                  e-form-group(
                  name="date_of_birth"
                  inputType="calendar"
                  label="Дата рождения"
                  :model="fields"
                    :required="false"
                  tabView="tab1"
                  )
                  e-form-group(
                  name="snils"
                  inputType="input"
                  label="Снилс"
                  :model="fields"
                    :required="false"
                  tabView="tab1"
                  )
                  e-form-group(
                  name="phone"
                  inputType="input"
                  label="Телефон"
                  :model="fields"
                  tabView="tab1"
                  )

                e-form-subtitle(text="Информация о документе, удостоверяющем личность")

                div.col-sub-cols-2
                  e-form-group(
                  name="identity_card_type_id"
                  inputType="select"
                  label="Вид"
                  :model="fields"
                    :required="false"
                  tabView="tab1"
                  :options="identityCardTypes"
                  )
                  e-form-group(
                  name="identity_card_issue_date"
                  inputType="calendar"
                  label="Дата"
                  :model="fields"
                    :required="false"
                  tabView="tab1"
                  )
                  e-form-group(
                  name="identity_card_number"
                  inputType="input"
                  label="Номер"
                  :model="fields"
                    :required="false"
                  tabView="tab1"
                  validationRule="number"
                  )
                  e-form-group(
                  name="identity_card_series"
                  inputType="input"
                  validationRule="number"
                  label="Серия"
                  :model="fields"
                    :required="false"
                  tabView="tab1"
                  )

              div.col
                e-form-subtitle(text="Лицевые счета")
                div.accounts
                  e-table-inner(
                  :itemsEndpoint="individualAccountsEndpoint"
                  :showDeleteButton="false"
                  :defaultColWidth="120"
                  )

                account-holidays(
                  :model="fields"
                  :dataUrl="accountHolidayDataUrl"
                  tabView="individuals"
                  :formValidator="formValidator"
                  validate-alias="accounts"
                  ref="accountHolidays"
                )

</template>

<script>
  import {individuals, core} from '../../api/api-endpoints.js'
  import individualsForm from './mixins/individuals-form'
  import AccountHolidays from "./components/account-holidays";

  export default {
    components: {AccountHolidays},
    mixins: [individualsForm],
    data () {
      return {
        tabView: 'tab1',
        fields: {}
      }
    },
    methods: {
      getCollectionEndpoint () {
        return core.collection('identity_card_type')
      },
      getDeleteUrl (id) {
        return individuals.individualDelete(id)
      },
      getUpdateOrCreateUrl () {
        return individuals.individualUpdateOrCreate(this.itemId)
      },
      getItemEndpoint (route) {
        // когда вставлена внуть друго модалки, котоая внутри модалки
        // https://redmine.etton.ru/issues/15244
        if (route.name.endsWith('create')) {
          return null
        }
        return individuals.individual(route.params.id)
      }
    }
  }
</script>
